import React from 'react';

const About = () => {
  return (
    <section className="bg-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-black mb-8 font-serif">About Worknetix Solutions</h1>
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Worknetix Staffing Solutions Pvt Ltd, in partnership with Fino Bank, is a leading provider of comprehensive staffing solutions and banking services across India and internationally. We are committed to connecting top talent with opportunities and providing accessible financial services.
              </p>
              <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">Our Mission</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                To bridge the gap between talented professionals and leading organizations while providing inclusive banking solutions through Fino Bank. We strive to be the gold standard in staffing and financial services through innovation, professionalism, and unwavering commitment to excellence.
              </p>
              <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">Our Vision</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                To become the most trusted and preferred partner for staffing solutions and banking services, recognized for our integrity, reliability, and comprehensive solutions that exceed client and customer expectations.
              </p>
              <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">Why Choose Us</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                <li>Extensive experience in staffing and recruitment</li>
                <li>Partnership with Fino Bank for comprehensive banking solutions</li>
                <li>Dedicated support and personalized service</li>
                <li>State-of-the-art technology for talent matching</li>
                <li>Compliance with all regulatory requirements</li>
                <li>Customized solutions for diverse hiring needs</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
  );
};

export default About;
